import { LinkExternal } from "@mgdx/ui/components/Link";
import { type ComponentProps } from "react";

import { useAppExternalLink } from "../../hooks/useAppExternalLink";

export type AppExternalLinkProps = Omit<ComponentProps<typeof LinkExternal>, "target">;

export const AppExternalLink = ({ href, onClick, ...props }: AppExternalLinkProps) => {
  const { href: resolvedHref, onClick: resolvedOnClick, target } = useAppExternalLink({ href, onClick });

  return <LinkExternal {...props} href={resolvedHref} target={target} onClick={resolvedOnClick} />;
};
